<template>
    <div class="flex items-center justify-center h-screen" style="height: 100dvh">
        <div class="flex flex-col items-center justify-center">
            <div
                class="rounded-xl p-1 bg-gradient-to-b from-red-500 to-transparent bg-white dark:bg-black"
            >
                <div
                    class="bg-white dark:bg-black w-full py-8 px-5 sm:px-8 flex flex-col items-center rounded-xl max-h-[90vh] max-w-[90vw] mx-auto"
                >
                    <div class="flex flex-col items-center text-center">
                        <i
                            class="fal fa-exclamation-circle text-5xl text-white"
                            style="color: red"
                        ></i>
                        <h1 class="font-bold text-3xl mb-2">
                            {{ $t(title) }}
                        </h1>
                        <div v-html="$t(subTitle)" class="mb-5"></div>
                        <div class="flex justify-center">
                            <img src="/error.webp" alt="Error" class="mb-5" width="350px" />
                        </div>
                        <div class="w-full text-center">
                            <NuxtLink
                                :to="
                                    props.error.statusCode && !token
                                        ? '/'
                                        : props.error.statusCode && token && checkToken
                                        ? ((menu || [])[0] || {}).route || '/'
                                        : '/'
                                "
                            >
                                <Button
                                    :label="
                                        props.error.statusCode && !token
                                            ? $t('error_effettua_login')
                                            : props.error.statusCode && token && checkToken
                                            ? $t('error_torna_pagina_iniziale')
                                            : $t('error_effettua_login')
                                    "
                                    class="bg-red-500 text-white hover:bg-red-600"
                                    style="border: unset !important"
                                    icon="fal fa-arrow-left"
                                ></Button>
                            </NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const { $localStorage } = useNuxtApp();
const props = defineProps(['error']);
const env = useRuntimeConfig();
const BASE_PROGETTO = env.public.base_progetto;
const token = useCookie(`token${env.public.base_progetto}`).value;

const title =
    props.error.statusCode === 404
        ? 'error_titolo_404'
        : props.error.statusCode === 401
        ? 'error_titolo_401'
        : 'error_titolo_generale';
const subTitle =
    props.error.statusCode === 404
        ? 'error_sottotitolo_404'
        : props.error.statusCode === 401
        ? 'error_sottotitolo_401'
        : 'error_sottotitolo_generale';
const checkToken = ref(false);
const menu = JSON.parse($localStorage.getItem('menu') || null) || [];

onMounted(async () => {
    const token = useCookie(`token${BASE_PROGETTO}`).value;

    if (isString(token)) {
        await $fetch('/api/general/checkToken', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + useCookie(`token${BASE_PROGETTO}`).value,
            },
        })
            .then((res) => {
                checkToken.value = res;
            })
            .catch(() => {
                checkToken.value = false;
            });
    } else {
        checkToken.value = false;
    }
});
</script>
